import { render, staticRenderFns } from "./product_details_two.vue?vue&type=template&id=0d8a3864&scoped=true&"
import script from "./product_details_two.vue?vue&type=script&lang=js&"
export * from "./product_details_two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a3864",
  null
  
)

export default component.exports